<ng-container *ngIf="icons">
  <span class="fs" [class]="icons[0].name">
    <ng-container *ngIf="icons[0].path">
      <span *ngFor="let item of icons[0]?.path; let i = index" class="path{{ i }}"></span>
    </ng-container>
  </span>
</ng-container>
